/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Completed_SuccessfullyInputs */



/**
* | output |
* | --- |
* | "Sync completed successfully" |
*
* @param {Team_Sync_Completed_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_completed_successfully = /** @type {((inputs?: Team_Sync_Completed_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Completed_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation terminée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierung erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione completata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синхронизация успешно завершена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización completada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("同步已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期が正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक्रोनाइज़ेशन सफलतापूर्वक पूरा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronização concluída com sucesso")
	return /** @type {LocalizedString} */ ("Sync completed successfully")
});